import * as React from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Button": Button, "@mui/material/Avatar": Avatar, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemAvatar": ListItemAvatar, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemText": ListItemText, "@mui/material/DialogTitle": DialogTitle, "@mui/material/Dialog": Dialog, "@mui/icons-material/Person": PersonIcon, "@mui/icons-material/Add": AddIcon, "@mui/material/Typography": Typography, "@mui/material/colors": { blue } } } });
export default ClientProvider;
